<template>
  <dash-input-modal
    ref="dashInputModal"
    name="market-name-modal"
    header="Market name should be specified"
    confirm-text="Create Market"
    :disabled="!isNameSpecified"
  >
    <div slot="contents">
      <input
        v-model="customMarketName"
        type="text"
        class="text-input"
      >
    </div>
  </dash-input-modal>
</template>
<script>
import DashInputModal from '@/components/common/DashInputModal';
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'MarketNameModal',
  components: {
    DashInputModal,
  },
  computed: {
    customMarketName: {
      ...mapState('customMarket', { get: 'name' }),
      ...mapMutations('customMarket', { set: 'setName' }),
    },
    ...mapGetters('customMarket', ['isNameSpecified']),
  },
  methods: {
    confirm() {
      return this.$refs.dashInputModal.confirm();
    },
  },
};
</script>
<style lang="scss" scoped>
.text-input {
  border: 1px solid #333333;
  border-radius: 2px;
  background-color: #1E1D1D;
  height: 100%;
  width: 100%;
  outline: none;
  padding: 12px;
  color: white;
  font-size: 17px;
  font-family: Lato;
  line-height: 21px;
  box-sizing: border-box;
}
</style>
